import React from "react";
import { Box } from "@mui/material";
import { Charge } from "modules/equipment/types";
import { DiscountType } from "@trnsact/trnsact-shared-types";
import { ListingForm } from "components/shared/TableListing/types";
import { FieldPath, useFormContext, useWatch } from "react-hook-form";
import { CurrencyInputField, InterestInputField, RadioGroupField } from "components/form";
import { QuoteChargeListingEntity } from "../../../../../types";
import { CHARGE_ROW_HEIGHT, chargeTypeOptions } from "../../../../../constants/form";

interface Props {
  rowIndex: number;
  type: keyof Charge;
  attachmentIndex: number;
}

export const AttachmentChargeWithTypeValue = ({ rowIndex, type, attachmentIndex }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const fields: Record<"valuePath" | "typePath", FieldPath<ListingForm<QuoteChargeListingEntity>>> = {
    valuePath: `bodyFields.${rowIndex}.equipment.attachments.${attachmentIndex}.price.${type}`,
    typePath: `bodyFields.${rowIndex}.equipment.attachments.${attachmentIndex}.price.${type}Type` as any,
  };

  const fieldType = useWatch({ control, name: fields.typePath });

  const fieldMapper: Record<DiscountType, any> = {
    [DiscountType.Percent]: (
      <InterestInputField control={control} name={fields.valuePath} textFieldProps={{ variant: "outlined" }} />
    ),
    [DiscountType.Flat]: (
      <CurrencyInputField
        allowNegative
        control={control}
        name={fields.valuePath}
        textFieldProps={{ variant: "outlined" }}
      />
    ),
  };

  return (
    <Box height={CHARGE_ROW_HEIGHT}>
      {fieldMapper[fieldType as DiscountType]}

      <RadioGroupField row control={control} name={fields.typePath} options={chargeTypeOptions} />
    </Box>
  );
};
